var NoContent = React.createClass({
  propTypes: {
    message: React.PropTypes.string,
    center: React.PropTypes.bool
  },
  getDefaultProps() {
    return {
      message: "",
      center: true
    }
  },
  render() {
    return (
      <div className={classNames("no-content", {"-center": this.props.centered})}>
        {this.props.message}
        {this.props.children}
      </div>
    )
  }
})